<!-- QRの読み取りで不正な文字列だった場合などのダイアログ fnc毎に表示するエラータイトルは変わる -->
<template>
  <ItemDialog ref="QRFail" image-type="alert">
    <template #content-area>
      <p>
        {{ failTitle }}
      </p>
    </template>

    <template #button-area>
      <ItemButton
        label="戻る"
        action-type="btn-primary"
        @clicked="handleClick()"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogQRFail",
  props: {
    failTitle: {
      type: String,
    },
  },
  methods: {
    async openDialog() {
      this.$refs.QRFail.open();
    },
    async closeDialog() {
      this.$refs.QRFail.close();
    },
    handleClick() {
      this.closeDialog();
      this.$emit("clicked");
    },
  },
};
</script>
